import type { Property } from '@/types';

export const featuredProperties: Property[] = [
  {
    id: 'kt-2801',
    title: 'Kirana Two - High Zone Corner Suite',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-2801',
    floor: 28,
    zone: 'High Zone',
    condition: 'Fully Fitted',
    type: 'For Rent',
    category: 'High Zone Suite',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 380,
    area: '380 m²',
    price: 'IDR 83.6 Juta / bulan',
    numericPrice: 83600000,
    rentalRateSqm: 220000,
    serviceChargeSqm: 60000,
    ceilingHeight: '2.90 m',
    electricityCapacity: '45 kVA',
    parkingRatio: '1 : 80 m²',
    viewType: 'City Skyline North & Sea View',
    image: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Ruang Direksi & Ruang Rapat Terpisah',
      'Toilet Eksekutif Privat In-Suite',
      'Pantry Mewah dengan Granite Top',
      'Akses Lift Penumpang Kecepatan Tinggi (Zone High)',
      'AC VRV Independen per Zone',
      'Kaca Low-E Double Glazed (Peredam Panas & Suara)'
    ],
    description: 'Unit perkantoran sudut lantai tinggi di Kirana Two Office Tower dengan pemandangan lanskap kota dan laut lepas. Sudah dilengkapi dengan interior fit-out modern kelas atas, workstation modular, ruang meeting berkapasitas 12 orang, dan sistem keamanan pintu akses kartu pintar.',
    featured: true,
  },
  {
    id: 'kt-1604',
    title: 'Kirana Two - Mid Zone Modern Suite',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-1604',
    floor: 16,
    zone: 'Mid Zone',
    condition: 'Semi-Fitted',
    type: 'For Rent',
    category: 'Mid Zone Suite',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 215,
    area: '215 m²',
    price: 'IDR 43.0 Juta / bulan',
    numericPrice: 43000000,
    rentalRateSqm: 200000,
    serviceChargeSqm: 55000,
    ceilingHeight: '2.80 m',
    electricityCapacity: '25 kVA',
    parkingRatio: '1 : 100 m²',
    viewType: 'Boulevard Boulevard Garden View',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Plafon Gypsum & Pencahayaan LED Panel',
      'Raised Flooring Siap Kabel Data Cat6',
      'Jaringan Optik FTTH Multi-Operator',
      'Sistem Proteksi Kebakaran Sprinkler & Hydrant',
      'Keamanan 24/7 dengan CCTV HD Integrasi'
    ],
    description: 'Unit perkantoran semi-fitted fleksibel untuk perusahaan yang ingin mendesain tata letak meja kerja secara custom. Dilengkapi dengan lantai raised floor dan sistem kelistrikan yang terstruktur rapi.',
    featured: true,
  },
  {
    id: 'kt-3200',
    title: 'Kirana Two - Whole Floor Executive Space',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-3200',
    floor: 32,
    zone: 'High Zone',
    condition: 'Bare Shell',
    type: 'For Sale',
    category: 'Whole Floor Space',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 1250,
    area: '1,250 m²',
    price: 'IDR 37.5 Milyar (Strata Title)',
    numericPrice: 37500000000,
    rentalRateSqm: 0,
    serviceChargeSqm: 65000,
    ceilingHeight: '3.20 m Slab to Slab',
    electricityCapacity: '150 kVA',
    parkingRatio: '1 : 50 m²',
    viewType: '360° Panoramic City Skyline',
    image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Kepemilikan Hak Milik Atas Satuan Rumah Susun (Strata Title)',
      'Satu Lantai Penuh Tanpa Sekat (Column-Free Layout)',
      '4 Lift Eksekutif Penumpang + 1 Lift Servis Beban Berat',
      'Area Restroom Pria & Wanita Terpisah yang Luas',
      'Kapasitas Beban Lantai 250 kg/m²'
    ],
    description: 'Kesempatan langka memiliki 1 lantai penuh di lantai 32 Kirana Two Office Tower (Strata Title). Layout bebas kolom memudahkan perancangan ruang kerja kantor pusat, holding company, atau institusi keuangan.',
    featured: true,
  },
];
